import { atom, useAtom } from "jotai";
import { useState } from "react";

export type state = "success" | "error";
type Notification = {
  isOpen: boolean;
  status: state;
  message: string;
};

const notification = atom<Notification>({
  isOpen: false,
  status: "success",
  message: "",
});

export function useNotifcication() {
  const [state, setState] = useAtom(notification);
  const openNotification = ({
    status,
    message,
  }: {
    status: state;
    message: string;
  }) => {
    setState({
      ...state,
      isOpen: true,
      status,
      message,
    });
  };

  const closeNotification = () => {
    setState({
      ...state,
      isOpen: false,
    });
  };

  return { ...state, openNotification, closeNotification };
}
